import {memo, type ReactNode} from "react";
import {HStack} from "@chakra-ui/react";
import {DrawerHeader, DrawerCloseTrigger} from "../../../../../components/ui/drawer";

/** Standard gray drawer header with inline close button. Pass actions (buttons) as `children`. */
export const DrawerPageHeader = memo(({title, children}: {title: ReactNode; children?: ReactNode}) => (
  <DrawerHeader bg="gray.50" borderBottom="1px solid {colors.gray.200}" py={3}>
    <HStack justify="space-between" align="center" w="full">
      {title}
      <HStack gap={2}>
        {children}
        <DrawerCloseTrigger position="static" top="unset" insetEnd="unset" />
      </HStack>
    </HStack>
  </DrawerHeader>
));
